document.addEventListener("DOMContentLoaded", () => {
    // Parse JSON data
    const product = JSON.parse(document.querySelector("script[data-custom-product]")?.textContent || '{}');
    const variant_metafields = JSON.parse(document.querySelector("script[data-variant-metafield]")?.textContent || '{"variants":[]}');
    const same_products = JSON.parse(document.querySelector("script[data-same-product]")?.textContent || '{"products":[]}');
    
    console.log("Product:", product);
    console.log("Same products:", same_products);
    
    // Get DOM elements
    const custom_variant_content = document.querySelector(".custom-variant-selector-content");
    const right_selectors = custom_variant_content?.querySelectorAll(".right-eye-variant-selector select[data-type='option']");
    const left_selectors = custom_variant_content?.querySelectorAll(".left-eye-variant-selector select[data-type='option']");
    const right_krzywizna = custom_variant_content?.querySelector(".right-eye-variant-selector select[data-type='krzywizna']");
    const left_krzywizna = custom_variant_content?.querySelector(".left-eye-variant-selector select[data-type='krzywizna']");
    const right_srednica = custom_variant_content?.querySelector(".right-eye-variant-selector select[data-type='srednica']");
    const left_srednica = custom_variant_content?.querySelector(".left-eye-variant-selector select[data-type='srednica']");
    const right_input = document.querySelector('#right-variant-id');
    const left_input = document.querySelector("#left-variant-id");
    const is_both = document.querySelector("#is-both");
    const availability_element = document.querySelector("#custom-availability-value");
    const right_quantity_element = custom_variant_content?.querySelector(".right-eye-variant-selector select[data-type='quantity']");
    const left_quantity_element = custom_variant_content?.querySelector(".left-eye-variant-selector select[data-type='quantity']");
    
    // State variables
    let right_values = {};
    let left_values = {};
    let right_availability = "";
    let left_availability = "";
    let right_selected_variant = null;
    let left_selected_variant = null;
    
    // Helper function to check if variant is available for selection
    const isVariantAvailable = (variant) => {
        return variant.available && variant.inventory_quantity > 0;
    };
    
    // Helper function to get available options for a specific combination
    const getAvailableOptions = (productData, option_position, currentValues, excludeValues = {}) => {
        const availableOptions = new Set();
        
        productData.variants.forEach(variant => {
            if (!isVariantAvailable(variant)) return;
            
            // Check if variant matches current values for other options
            let matches = true;
            for (let i = 1; i <= 3; i++) {
                if (i === option_position) continue;
                const optionKey = `option${i}`;
                if (currentValues[optionKey] && variant[optionKey] !== currentValues[optionKey]) {
                    matches = false;
                    break;
                }
            }
            
            // Check krzywizna and srednica
            if (currentValues.krzywizna && productData.krzywizna !== currentValues.krzywizna) matches = false;
            if (currentValues.srednica && productData.srednica !== currentValues.srednica) matches = false;
            
            if (matches) {
                const optionValue = variant[`option${option_position}`];
                if (optionValue && !excludeValues[optionValue]) {
                    availableOptions.add(optionValue);
                }
            }
        });
        
        return availableOptions;
    };
    
    // Function to update option availability
    const updateOptionAvailability = (side) => {
        const selectors = side === 'right' ? right_selectors : left_selectors;
        const values = side === 'right' ? right_values : left_values;
        const krzywizna_selector = side === 'right' ? right_krzywizna : left_krzywizna;
        const srednica_selector = side === 'right' ? right_srednica : left_srednica;
        
        // Find the correct product data
        let productData = same_products.products.find(p => 
            p.krzywizna === values.krzywizna && p.srednica === values.srednica
        );
        
        if (!productData) {
            productData = same_products.products[0]; // Fallback to first product
        }
        
        // Update option selectors
        if (selectors && productData) {
            selectors.forEach((selector, index) => {
                const option_position = index + 1;
                const currentValue = selector.value;
                const availableOptions = getAvailableOptions(productData, option_position, values);
                
                // Update options
                Array.from(selector.options).forEach(option => {
                    if (option.value === '') return; // Skip empty options
                    
                    if (availableOptions.has(option.value)) {
                        option.disabled = false;
                        option.style.display = '';
                    } else {
                        option.disabled = true;
                        option.style.display = 'none';
                    }
                });
                
                // If current selection is not available, select first available option
                if (currentValue && !availableOptions.has(currentValue)) {
                    const firstAvailable = Array.from(availableOptions)[0];
                    if (firstAvailable) {
                        selector.value = firstAvailable;
                        values[`option${option_position}`] = firstAvailable;
                    }
                }
            });
        }
        
        // Update krzywizna options
        if (krzywizna_selector) {
            const availableKrzywizna = new Set();
            same_products.products.forEach(p => {
                if (p.variants.some(v => isVariantAvailable(v))) {
                    availableKrzywizna.add(p.krzywizna);
                }
            });
            
            Array.from(krzywizna_selector.options).forEach(option => {
                if (availableKrzywizna.has(option.value)) {
                    option.disabled = false;
                    option.style.display = '';
                } else {
                    option.disabled = true;
                    option.style.display = 'none';
                }
            });
        }
        
        // Update srednica options
        if (srednica_selector) {
            const availableSrednica = new Set();
            same_products.products.forEach(p => {
                if (p.variants.some(v => isVariantAvailable(v))) {
                    availableSrednica.add(p.srednica);
                }
            });
            
            Array.from(srednica_selector.options).forEach(option => {
                if (availableSrednica.has(option.value)) {
                    option.disabled = false;
                    option.style.display = '';
                } else {
                    option.disabled = true;
                    option.style.display = 'none';
                }
            });
        }
    };
    
    // Function to find matching variant
    const findMatchingVariant = (values, side) => {
        const productData = same_products.products.find(p => 
            p.krzywizna === values.krzywizna && p.srednica === values.srednica
        );
        
        if (!productData) return null;
        
        const variant = productData.variants.find(v => {
            return v.option1 === values.option1 && 
                   (!values.option2 || v.option2 === values.option2) && 
                   (!values.option3 || v.option3 === values.option3);
        });
        
        return variant;
    };
    
    // Function to update quantity selector based on available stock
    const updateQuantitySelector = (variant, quantity_selector) => {
        if (!variant || !quantity_selector) return;
        
        const maxQuantity = Math.min(variant.inventory_quantity, 10); // Limit to 10 or available stock
        const currentValue = parseInt(quantity_selector.value) || 1;
        
        // Clear existing options
        quantity_selector.innerHTML = '';
        
        // Add new options based on available stock
        for (let i = 1; i <= maxQuantity; i++) {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = i;
            if (i === Math.min(currentValue, maxQuantity)) {
                option.selected = true;
            }
            quantity_selector.appendChild(option);
        }
        
        // If no stock available, add disabled option
        if (maxQuantity === 0) {
            const option = document.createElement('option');
            option.value = 0;
            option.textContent = 'Niedostępne';
            option.disabled = true;
            option.selected = true;
            quantity_selector.appendChild(option);
        }
    };
    
    // Function to select variant
    const selectVariant = (values, side) => {
        const variant = findMatchingVariant(values, side);
        const input = side === 'right' ? right_input : left_input;
        const quantity_selector = side === 'right' ? right_quantity_element : left_quantity_element;
        
        if (variant && input) {
            input.value = variant.variant_id;
            
            if (side === 'right') {
                right_selected_variant = variant;
                right_availability = variant.variant_availability;
            } else {
                left_selected_variant = variant;
                left_availability = variant.variant_availability;
            }
            
            // Update quantity selector based on stock
            updateQuantitySelector(variant, quantity_selector);
            
            console.log(`Selected ${side} variant:`, variant);
        } else {
            console.warn(`No matching variant found for ${side} eye:`, values);
            if (input) input.value = '';
        }
        
        // Update availability display
        updateAvailabilityDisplay();
    };
    
    // Function to update availability display
    const updateAvailabilityDisplay = () => {
        if (!availability_element) return;
        
        const rightHours = change_into_hours(right_availability);
        const leftHours = change_into_hours(left_availability);
        
        if (rightHours > leftHours) {
            availability_element.innerHTML = right_availability;
        } else if (leftHours > rightHours) {
            availability_element.innerHTML = left_availability;
        } else {
            availability_element.innerHTML = right_availability || left_availability || '';
        }
    };
    
    // Helper function to convert availability to hours
    const change_into_hours = (value) => {
        if (typeof value !== "string") return 0;
        
        const lowerValue = value.toLowerCase();
        if (lowerValue.includes('day') || lowerValue.includes('dni') || lowerValue.includes('dzień')) {
            return parseInt(value) * 24;
        } else {
            return parseInt(value) || 0;
        }
    };
    
    // Initialize values and event listeners
    const initializeSelector = (selectors, side) => {
        const values = side === 'right' ? right_values : left_values;
        const krzywizna_selector = side === 'right' ? right_krzywizna : left_krzywizna;
        const srednica_selector = side === 'right' ? right_srednica : left_srednica;
        
        // Initialize option values
        if (selectors) {
            selectors.forEach((selector, index) => {
                const option_position = index + 1;
                values[`option${option_position}`] = selector.value;
                
                selector.addEventListener("change", () => {
                    values[`option${option_position}`] = selector.value;
                    updateOptionAvailability(side);
                    selectVariant(values, side);
                });
            });
        }
        
        // Initialize krzywizna
        if (krzywizna_selector) {
            values.krzywizna = krzywizna_selector.value;
            krzywizna_selector.addEventListener("change", () => {
                values.krzywizna = krzywizna_selector.value;
                updateOptionAvailability(side);
                selectVariant(values, side);
            });
        }
        
        // Initialize srednica
        if (srednica_selector) {
            values.srednica = srednica_selector.value;
            srednica_selector.addEventListener("change", () => {
                values.srednica = srednica_selector.value;
                updateOptionAvailability(side);
                selectVariant(values, side);
            });
        }
        
        // Initial selection
        updateOptionAvailability(side);
        selectVariant(values, side);
    };
    
    // Initialize both sides
    initializeSelector(right_selectors, 'right');
    initializeSelector(left_selectors, 'left');
    
    // Handle "both eyes same" checkbox
    if (is_both) {
        is_both.addEventListener("change", () => {
            if (is_both.checked) {
                // Copy right values to left
                Object.assign(left_values, right_values);
                
                // Update left selectors to match right
                if (left_selectors && right_selectors) {
                    left_selectors.forEach((leftSelector, index) => {
                        if (right_selectors[index]) {
                            leftSelector.value = right_selectors[index].value;
                        }
                    });
                }
                
                if (left_krzywizna && right_krzywizna) {
                    left_krzywizna.value = right_krzywizna.value;
                }
                
                if (left_srednica && right_srednica) {
                    left_srednica.value = right_srednica.value;
                }
                
                selectVariant(left_values, 'left');
            }
        });
    }
    
    // Handle add to cart
    const add_to_cart_btn = document.querySelector("buy-button .product-form__add-button");
    if (add_to_cart_btn) {
        add_to_cart_btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const right_quantity = parseInt(right_quantity_element?.value) || 0;
            const left_quantity = parseInt(left_quantity_element?.value) || 0;
            const right_variant_id = right_input?.value;
            const left_variant_id = left_input?.value;
            
            // Validate selections
            if (!right_variant_id) {
                alert('Proszę wybrać wariant dla prawego oka.');
                return;
            }
            
            if (!is_both.checked && !left_variant_id) {
                alert('Proszę wybrać wariant dla lewego oka.');
                return;
            }
            
            // Validate quantities
            if (right_quantity <= 0 || (right_selected_variant && right_quantity > right_selected_variant.inventory_quantity)) {
                alert('Nieprawidłowa ilość dla prawego oka.');
                return;
            }
            
            if (!is_both.checked && (left_quantity <= 0 || (left_selected_variant && left_quantity > left_selected_variant.inventory_quantity))) {
                alert('Nieprawidłowa ilość dla lewego oka.');
                return;
            }
            
            // Prepare cart data
            const data = {
                items: [
                    {
                        "id": right_variant_id,
                        "quantity": right_quantity,
                        "properties": {
                            "Oko": "Prawe"
                        }
                    }
                ]
            };
            
            if (!is_both.checked) {
                data.items.push({
                    'id': left_variant_id, 
                    'quantity': left_quantity,
                    "properties": {
                        "Oko": "Lewe"
                    }
                });
            }
            
            console.log('Adding to cart:', data);
            
            // Add to cart
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(result => {
                console.log('Successfully added to cart:', result);
                
                // Dispatch success event
                document.documentElement.dispatchEvent(new CustomEvent("product:added", {
                    bubbles: true,
                    detail: {
                        button: e.target,
                        variant: null,
                        quantity: is_both.checked ? right_quantity : (right_quantity + left_quantity),
                        productAdded: true
                    }
                }));
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
                alert('Nie można dodać większej ilości – ograniczona dostępność produktu');
            });
        });
    }
});